import React from 'react';
import useResize from 'src/shared/hooks/useResize';
import ArticlePostModel from 'src/types/article/ArticlePostModel';
import ListItem from '../../../ListItem';
import useListItems from './hooks/useListItems';

interface Props {
    isFetchingAdditional: boolean;
    basicArticles: ArticlePostModel[];
    additionalArticles: ArticlePostModel[];
    featuredFromOthers: ArticlePostModel[];
}

const ArticleList = ({ isFetchingAdditional, basicArticles, additionalArticles, featuredFromOthers }: Props) => {
    const { screenSize, breakpoint } = useResize();
    const listItems = useListItems({
        breakpoint,
        basicArticles,
        additionalArticles,
        featuredFromOthers,
    });

    return (
        <div>
            {listItems.map((item, idx) => (
                <ListItem key={`list-item-${idx}`} type={item.type} item={item.content} items={item.contents} screenWidth={screenSize.width} />
            ))}
        </div>
    );
};

export default ArticleList;
